var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCard',{staticClass:"payment-method-wrapper",attrs:{"color":_vm.ColorType.white}},[_c('VSection',{attrs:{"title":"결제수단","padding":[25, 15, 5, 15],"useUnderline":false}}),_c('div',{attrs:{"id":"baemin-pay-rendered-component"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }